/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { useCanCreateFields } from '@jira/polaris__component-permissions-store/src/useCanCreateFields.tsx';
import { useIsViewTemplateButtonVisible } from '@jira/polaris__component-view-template-library/src/useIsViewTemplateButtonVisible.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	ActionButtonCreateViewOld,
	type ActionButtonCreateViewProps,
} from './ActionButtonCreateViewOld.tsx';
import { ActionButtonCreateViewNew } from './ActionButtonCreateViewNew.tsx';
import { isNavigationProject } from '../../common/types.tsx';
import { useJpdNavCanManageViews } from '../../controllers/context.tsx';

export const ActionButtonCreateView = ({
	container,
	sectionId,
	navigationContainer,
}: ActionButtonCreateViewProps): React.JSX.Element => {
	const canManageViews = useJpdNavCanManageViews();
	const canCreateFields = useCanCreateFields();

	const isProjectContainer = isNavigationProject(navigationContainer);
	const projectId = isProjectContainer ? navigationContainer.projectId : undefined;
	const projectKey = isProjectContainer ? navigationContainer.projectKey : undefined;

	const isViewTemplateButtonVisible = useIsViewTemplateButtonVisible({
		canCreateFields,
		canManageViews,
		projectId,
		projectKey,
	});
	const isNewActionButtonEnabled =
		fg('view-templates-change-banner-placement') && isViewTemplateButtonVisible;

	if (isNewActionButtonEnabled) {
		return (
			<ActionButtonCreateViewNew
				navigationContainer={navigationContainer}
				container={container}
				sectionId={sectionId}
			/>
		);
	}

	return (
		<ActionButtonCreateViewOld navigationContainer={navigationContainer} container={container} />
	);
};
